import { render } from "./Socials.vue?vue&type=template&id=53750760&scoped=true"
import script from "./Socials.vue?vue&type=script&lang=js"
export * from "./Socials.vue?vue&type=script&lang=js"

import "./Socials.vue?vue&type=style&index=0&id=53750760&scoped=true&lang=css"

import exportComponent from "/opt/buildhome/repo/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-53750760"]])

export default __exports__